import { render, staticRenderFns } from "./KgRightbar.vue?vue&type=template&id=2738be02&scoped=true"
import script from "./KgRightbar.vue?vue&type=script&lang=js"
export * from "./KgRightbar.vue?vue&type=script&lang=js"
import style0 from "./KgRightbar.vue?vue&type=style&index=0&id=2738be02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738be02",
  null
  
)

export default component.exports